import { render, staticRenderFns } from "./FreeAgents.vue?vue&type=template&id=ddb039c6&scoped=true&"
import script from "./FreeAgents.vue?vue&type=script&lang=js&"
export * from "./FreeAgents.vue?vue&type=script&lang=js&"
import style0 from "./FreeAgents.vue?vue&type=style&index=0&id=ddb039c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb039c6",
  null
  
)

export default component.exports